module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 11-253214a4215379d6aa92c4c68365b521.jpg";